import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=f4d4e046"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports